import Highcharts from "highcharts";

const noDataStyle = {
  style: {
    fontWeight: "bold",
    fontSize: "15px",
    color: "#303030",
  },
  useHTML: true,
};

const legend = function(enabled) {
  return {
    enabled: enabled,
    useHTML: enabled,
  };
};

const exporting = function(enabled) {
  return {
    enabled: enabled,
  };
};

const title = function(enabled) {
  return {
    enabled: enabled,
    useHTML: enabled,
    text: undefined,
  };
};

const tooltip = {
  default: {
    shared: true,
    useHTML: true,
    headerFormat: "<small>{point.key}</small><table>",
    pointFormat:
      '<tr><td style="color: {series.color}">{series.name}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    footerFormat: "</table>",
    valueDecimals: 2,
    split: false,
    xDateFormat: "%A,%Y-%m-%d",
  },
  numericXAxisToolTip: {
    shared: true,
    useHTML: true,
    headerFormat: "<small><strong>DOC:{point.x}</strong></small><table>",
    pointFormat:
      '<tr><td style="color: {series.color}">{series.name}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    footerFormat: "</table>",
    valueDecimals: 2,
    split: false,
  },
  pondScheduleToolTip: {
    shared: true,
    useHTML: true,
    headerFormat: "<small>{point.key}</small><table>",
    pointFormat:
      '<tr><td style="color: {series.color}">{series.name.tooltip}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    footerFormat: "</table>",
    valueDecimals: 2,
    split: false,
    xDateFormat: "%A,%Y-%m-%d",
  },
  hourlyToolTip: {
    shared: true,
    useHTML: true,
    headerFormat: "<small>{point.key}</small><table>",
    pointFormat:
      '<tr><td style="color: {series.color}">{series.name}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    footerFormat: "</table>",
    valueDecimals: 2,
    split: false,
    xDateFormat: "%A,%Y-%m-%d %H:%M",
  },
  stOCFToolTip: {
    shared: true,
    useHTML: true,
    headerFormat: "<small>{point.key}</small>",
    pointFormat:
      '<br><table><span style="color:#255379">OCF(g)</span>: <b>{point.y}</b><br/><span style="color:#255379">FGI (min)</span>: <b>{point.info.fgi}</b><br/><span style="color:#255379">OCF(g)({point.info.pms}-PondMothers)</span>: <b>{point.info.total_ocf}</b>',
    footerFormat: "</table>",
    valueDecimals: 2,
    split: false,
    xDateFormat: "%A,%Y-%m-%d %H:%M",
  },
  pgStatusToolTip: {
    shared: true,
    useHTML: true,
    headerFormat: "<small>{point.key}</small><table>",
    pointFormat:
      '<tr><td style="color: {series.color}">{series.name.series_name}: </td>' +
      '<td style="text-align: right"><b>{point.y}</b></td></tr>',
    footerFormat:
      "<tr><td style='color:#000000'><b>{series.name.device_code_text}:</b></td><td style='text-align: right'><b>{series.name.device_code}</b></td></tr></table>",
    valueDecimals: 2,
    split: false,
    xDateFormat: "%A,%Y-%m-%d %H:%M",
  },
};

const legendObj = {
  default: {
    legend: true,
  },
  pondScheduleLegend: {
    enabled: true,
    useHTML: true,
    labelFormatter: function() {
      return this.name.legend;
    },
  },
  manualFeedGraph: {
    enabled: true,
    useHTML: true,
    labelFormatter: function() {
      return this.name.legend;
    },
  },
  AbwBiomassGraphConfig: {
    enabled: true,
    useHTML: true,
    labelFormatter: function() {
      return this.name.legend;
    },
  },

  pgStatusGraph: {
    enabled: true,
    useHTML: true,
    labelFormatter: function() {
      return this.name.series_name;
    },
  },
};

const baseGraphConfig = {
  plotOptions: {
    series: {
      turboThreshold: 10000000,
      pointInterval: 24 * 3600 * 1000, // one daym
    },
  },
  credits: {
    enabled: false,
  },
  scrollbar: {
    enabled: true,
    height: 10,
    showFull: false,
  },
  rangeSelector: {
    enabled: false,
  },
  navigator: {
    enabled: false,
  },
  noData: noDataStyle,
  tooltip: tooltip.default,
  series: [],

  colors: [
    "#4572A7",
    "#AA4643",
    "#89A54E",
    "#80699B",
    "#3D96AE",
    "#DB843D",
    "#92A8CD",
    "#A47D7C",
    "#B5CA92",
  ],
  chart: {
    zoomType: "x",
    resetZoomButton: {
      theme: {
        zIndex: 2000,
      },
    },
  },
  xAxis: {
    events: {
      afterSetExtremes: () => {},
    },
    type: "datetime",
    title: {
      text: "",
      align: "middle",
      style: {
        color: "#000000",
      },
    },
  },
  yAxis: {
    showEmpty: true,
    opposite: false,
    title: {
      text: "",
      align: "middle",
      textAlign: "center",
      style: {
        color: "#000000",
      },
    },
  },
};

const pondHourlyGraphConfig = {
  ...baseGraphConfig,
  tooltip: { ...tooltip.hourlyToolTip },
  time: {
    useUTC: false,
  },
  legend: legend(true),
  exporting: exporting(false),
  title: title(false),
};

const stOCFGraphConfig = {
  ...baseGraphConfig,
  tooltip: { ...tooltip.stOCFToolTip },
  time: {
    useUTC: false,
  },
  legend: legend(true),
  exporting: exporting(false),
  title: title(false),
};

const stGraphConfig = {
  ...baseGraphConfig,
  tooltip: { ...tooltip.hourlyToolTip },
  time: {
    useUTC: false,
  },
  legend: legend(true),
  exporting: exporting(false),
  title: title(false),
  xAxis: {
    events: {
      afterSetExtremes: () => {},
    },
    type: "datetime",
    title: {
      align: "middle",
    },
    minRange: 3600 * 1000,
    tickAmount: 24,
    showEmpty: true,
  },
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}",
        style: {
          color: "#000000",
        },
      },
      title: {
        text: "",
        style: {
          color: "#000000",
        },
      },
      opposite: false,
    },
    {
      // Tertiary yAxis
      title: {
        text: "",
        style: {
          color: "#000000",
        },
      },
      labels: {
        format: "{value}",
        style: {
          color: "#000000",
        },
      },
      opposite: true,
    },
  ],
};

const pondScheduleGraphConfig = {
  ...baseGraphConfig,
  tooltip: { ...tooltip.pondScheduleToolTip },
  xAxis: {
    events: {
      afterSetExtremes: () => {},
    },
    type: "datetime",
    title: {
      align: "middle",
    },
    minRange: 3600 * 1000,
  },
  legend: legendObj.pondScheduleLegend,
  exporting: exporting(false),
  title: title(false),
};

const pgStatusGraphConfig = {
  ...baseGraphConfig,
  tooltip: { ...tooltip.pgStatusToolTip },
  legend: legendObj.pgStatusGraph,
  exporting: exporting(false),
  title: title(false),
  plotOptions: {
    series: {
      turboThreshold: 10000000,
      connectNulls: true,
    },
  },
  xAxis: {
    showEmpty: false,
    ordinal: false, // Displays straight line if data is not there for a two timestamps
    labels: {
      style: {
        color: "#000000",
      },
    },
    title: {
      align: "middle",
    },
    minRange: 3600 * 1000, // one hour
    type: "datetime",
  },
  yAxis: [
    {
      // DO
      showEmpty: false,
      tickAmount: 4,
      gridLineWidth: 0,
      title: {
        style: {
          color: "#000000",
        },
      },
      labels: {
        // format: "{value} mm",
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
      opposite: false,
    },
    {
      // pH
      showEmpty: false,
      gridLineWidth: 0,
      visible: false,
      title: {
        style: {
          color: Highcharts.getOptions().colors[1],
        },
      },
      labels: {
        // format: "{value} mb",
        style: {
          color: "#000000",
        },
      },
      opposite: false,
    },
    {
      // temp
      showEmpty: false,
      tickAmount: 3,
      labels: {
        // format: "{value}°C",
        style: {
          color: "#000000",
        },
      },
      title: {
        style: {
          color: "#000000",
        },
      },
      opposite: true,
    },
  ],
};

const pmScheduleGraph = {
  ...baseGraphConfig,
  legend: legend(true),
  exporting: exporting(false),
  title: title(false),
};

const manualFeedGraph = {
  ...baseGraphConfig,
  legend: legend(true),
  exporting: exporting(false),
  title: title(false),
};

const AbwBiomassGraphConfig = {
  ...baseGraphConfig,
  legend: legend(true),
  exporting: exporting(false),
  title: title(false),
  tooltip: tooltip.numericXAxisToolTip,
  xAxis: [
    {
      gridLineColor: "#eeeeee",
      gridLineWidth: 0.5,
      title: {
        text: "DOC",
      },
      labels: {
        formatter: function() {
          return this.value;
        },
      },
    },
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        format: "{value}",
        style: {
          color: "#000000",
        },
      },
      title: {
        text: "Weight",
        style: {
          color: "#000000",
        },
      },
      opposite: false,
    },
    {
      // Tertiary yAxis
      title: {
        text: "Biomass / survival rate",
        style: {
          color: "#000000",
        },
      },
      labels: {
        format: "{value}",
        style: {
          color: "#000000",
        },
      },
      opposite: true,
    },
  ],
};

// admin pg charts
const pHGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};
const oxygenGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};
const airTempertureGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};
const airPressureGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};
const temperatureGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};
const solarVoltageGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};
const lithiumBatteryGraphConfig = {
  ...baseGraphConfig,
  legend: legend(false),
  exporting: exporting(true),
  title: title(true),
};

export {
  stGraphConfig,
  stOCFGraphConfig,
  pondHourlyGraphConfig,
  pondScheduleGraphConfig,
  pgStatusGraphConfig,
  pmScheduleGraph,
  pHGraphConfig,
  oxygenGraphConfig,
  airTempertureGraphConfig,
  airPressureGraphConfig,
  temperatureGraphConfig,
  solarVoltageGraphConfig,
  lithiumBatteryGraphConfig,
  manualFeedGraph,
  AbwBiomassGraphConfig,
};
